import type { BrowserOptions } from '@sentry/react';

const SENTRY_DSN = import.meta?.env?.VITE_SENTRY_DSN ?? '';

/** jobmeeting은 VITE_RUNTIME_ENV 사용: development | staging | staging2 | production */
const currentEnv =
  (import.meta.env.VITE_RUNTIME_ENV as string) ?? 'development';
const isLocal = currentEnv === 'local' || currentEnv === 'development';
const isStaging = currentEnv === 'staging' || currentEnv === 'staging2';
const isProduction = currentEnv === 'production';

/**
 * 환경별 샘플링 비율 (다른 앱과 동일)
 * - staging: 재현/검증 시 이벤트 수집 확률 높음
 * - production: 비용 절감을 위해 낮게 유지
 */
function getSampleRates() {
  if (isLocal) return { traces: 0, replaySession: 0, replayOnError: 0 };
  if (isStaging) return { traces: 0.1, replaySession: 0.1, replayOnError: 1 };
  if (isProduction)
    return { traces: 0.005, replaySession: 0.005, replayOnError: 0.005 };
  return { traces: 0.01, replaySession: 0.01, replayOnError: 0.1 };
}

export const sentryClientOptions: BrowserOptions = {
  dsn: SENTRY_DSN,
  environment: currentEnv,
  debug: !isProduction,
  tracesSampleRate: getSampleRates().traces,
  replaysSessionSampleRate: getSampleRates().replaySession,
  replaysOnErrorSampleRate: getSampleRates().replayOnError,
};

export const isLocalEnv = isLocal;
